import React, { useState } from "react";
import { BiTrash } from "react-icons/bi";
import x from '../../../../utils/Icons/X.svg';
import PropTypes from 'prop-types';

export const ProductCardThumbnail = ({ data, setData }) => {
  const [uploadedImage, setUploadedImage] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setUploadedImage(reader.result);
        setData(prevData => ({
          ...prevData,
          productCardThumbnail: { image: reader.result }
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteImage = () => {
    setUploadedImage(null);
    setData(prevData => ({
      ...prevData,
      productCardThumbnail: {}
    }));
  };

  return (
    <div className="bg-[#F0F0F0] dark:bg-[#282828] p-4 rounded my-4">
      <div className="flex items-center space-x-2">
        <div className="bg-[#CBF0D0] w-4 h-4 rounded" />
        <h1>Product Card or Thumbnail</h1>
      </div>

      <div className="md:flex items-center md:space-x-8 my-4">
        {!uploadedImage ? (
          <div className="border-[1px] border-gray-600 border-dashed shrink-0 relative w-fit p-10 rounded-lg cursor-pointer">
            <button className="bg-white cursor-pointer text-black px-4 py-2 rounded ">
              Upload Image
            </button>
            <input
              className="w-full cursor-pointer opacity-0 absolute inset-0"
              type="file"
              onChange={handleImageUpload}
              aria-label="Upload Image"
            />
          </div>
        ) : (
          <div className="flex items-center space-x-4 relative w-[184px] h-[150px] rounded-lg">
            <img
              className="w-full h-full object-cover rounded-lg"
              src={uploadedImage}
              alt="Uploaded Thumbnail"
            />
            <div
              onClick={handleDeleteImage}
              className="hidden md:flex absolute -top-2 -right-3 bg-[#E85959] text-white h-5 w-5 p-1.5 rounded-full items-center justify-center cursor-pointer"
              aria-label="Delete Image"
            >
              <img src={x} alt="Delete" />
            </div>
            <div
              onClick={handleDeleteImage}
              className="md:hidden flex items-center space-x-1 shrink-0 border-[1px] border-[#F08383] text-[#F08383] p-2 rounded-lg cursor-pointer"
              aria-label="Delete Image"
            >
              <BiTrash />
              <p>Delete</p>
            </div>
          </div>
        )}

        <p className="md:hidden text-center md:w-3/4 pt-4 dark:text-white">
          The image should have a 4:3 aspect ratio, be at least 800x600 pixels in size, and saved in either JPG, PNG, or GIF format.
          <br />
          <span className="opacity-60">The picture is visible among the many items on the feed, so be creative.</span>
        </p>

        <p className="hidden md:block opacity-60 md:text-center md:w-3/4 pt-4">
          The picture is visible among the many items on the feed, so be creative. The image should have a 4:3 aspect ratio, be at least 800x600 pixels in size, and saved in either JPG, PNG, or GIF format.
        </p>
      </div>
    </div>
  );
};


